import { computed as s, unref as m } from "vue";
function n(e, r = 0) {
  return Array.from({ length: e }, (t, o) => o + r + 1);
}
function g(e) {
  switch (e) {
    case "extra-small":
      return {
        maximumVisiblePageCount: 5,
        boundaryPageCount: 1,
        siblingPageCount: 0
      };
    case "small":
      return {
        maximumVisiblePageCount: 7,
        boundaryPageCount: 1,
        siblingPageCount: 1
      };
    case "medium":
      return {
        maximumVisiblePageCount: 9,
        boundaryPageCount: 1,
        siblingPageCount: 2
      };
    case "large":
      return {
        maximumVisiblePageCount: 11,
        boundaryPageCount: 2,
        siblingPageCount: 2
      };
    default:
      throw new Error(`Unknown size: ${e}`);
  }
}
function l({
  pageCount: e,
  currentPage: r,
  size: t
}) {
  const { maximumVisiblePageCount: o, boundaryPageCount: i, siblingPageCount: u } = g(t);
  if (e <= o)
    return n(e);
  const a = o - i - u - 1;
  return r <= a ? [
    ...n(a + u),
    "…",
    ...n(i, e - i)
  ] : r > e - a ? [
    ...n(i),
    "…",
    ...n(a + u, e - a - u)
  ] : [
    ...n(i),
    "…",
    ...n(u * 2 + 1, r - u - 1),
    "…",
    ...n(i, e - i)
  ];
}
function P({
  pageCount: e,
  currentPage: r,
  size: t
}) {
  return s(() => l({
    pageCount: m(e),
    currentPage: m(r),
    size: m(t)
  }));
}
export {
  P as default
};
//# sourceMappingURL=design-system.es117.js.map
